import { createStore, withProps } from '@ngneat/elf';
import { Agpm, AgpmDto } from '@/types';
import { SelectOption } from '@/components/form-builder/form-builder.types';

export interface AgpmStateProps {
  response: Agpm;
  dto?: Partial<AgpmDto>;
  acsSelected?: SelectOption;
  agpmServerObject?: Partial<AgpmDto>;
  //dowbload
  download: {
    signPerson: string;
    function: string;
  };
  upload: {
    modelPpmFile: File[];
  };
}

export const agpmInitialState: AgpmStateProps = {
  response: {
    id: 0,
    version: 0,
    ref: '',
    nom: '',
    annee: new Date().getFullYear().toString(),
    contenu: '',
    remarque: '',
    status: '',
    ac: { id: 0, nom: '', ancrage: '', contact: '' },
    docs: [],
    processInstanceId: null,
    actualise: false,
    modelAlfrescoId: null,
    nbrActualisation: 0,
  },
  dto: { ref: '', nom: '', acId: undefined, contenu: '', annee: new Date().getFullYear().toString(), remarque: '', docIds: [], files: [] },
  acsSelected: { name: '', code: 0 },

  agpmServerObject: {},
  download: {
    signPerson: '',
    function: '',
  },
  upload: {
    modelPpmFile: [],
  },
};

export const agpmStateStore = createStore(
  { name: 'agpm-state' },
  withProps<AgpmStateProps>({
    ...agpmInitialState,
  })
);
